import { render, staticRenderFns } from "./AgentAvatar.vue?vue&type=template&id=3861c948"
import script from "./AgentAvatar.vue?vue&type=script&lang=js"
export * from "./AgentAvatar.vue?vue&type=script&lang=js"
import style0 from "./AgentAvatar.vue?vue&type=style&index=0&id=3861c948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports